import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Container, Row, Col, Card } from "react-bootstrap";
import "./scholarship.css"
import ImageCropperModal from "./imagecropmodal";
import { eventsmasterlist, formcomptypelist, formemailcheck, formmobilecheck, formregsave, schformdetail, schformlist } from "../../services/superadmin";
import { useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { sportslist } from "../../services/master";
import trackobj from "../trackingpages.json";
import dotracking from "../trackinglogs";
export const AthleteScholarship = () => {
    const { id } = useParams();
    const [showModal, setShowModal] = useState(true);
    const [step1submit, setStep1Submit] = useState(false);
    const [step2submit, setStep2Submit] = useState(false);
    const [step3submit, setStep3Submit] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [formDetails, setFormDetails] = useState(null);
    const [clist, setCList] = useState([]);
    const [elist, setEList] = useState([]);

    const [slist, setSList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [formid, setFormID] = useState(0);
    const [sucmsg, setSucMsg] = useState(false);
    const [formphoto, setFormPhoto] = useState(null);

    const [step, setStep] = useState(0);
    const [formData, setFormData] = useState({
        // Personal
        name: "",
        dob: "",
        gender: "",
        permanentAddress: "",
        communicationAddress: "",
        mobile: "",
        email: "",
        education: "",
        height: "",
        weight: "",
        medicalCondition: "",
        // Sports
        sport: "",
        coachName: "",
        coachMobile: "",
        coachEmail: "",
        coachDesgination: "",
        coachQualification: "",
        coachDescription: "",
        // Achievements
        achievements: [
            { comp_id: "", event_id: "", date: "", competition: "", position: "", score: "", certificate: null },
        ],
        //Family
        fatherName: "",
        fatherOccu: "",
        motherName: "",
        familyIncome: "",
        proofIncome: "",
        // Reference
        referrences: [
            { name: "", designation: "", mobile: "", email: "" },
        ],
        idProof: null,
        bankPassbook: null,
        trainingPhoto: null,
        source: "",
        otherSource: "",
        acknowledge: "",

    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const [formListRes, sportsListRes] = await Promise.all([
                    schformlist(),
                    sportslist()
                ]);

                if (formListRes.status === true) {
                    const sdata = formListRes.data.scholarship_forms.find(
                        (item) => item.form_url_id == id
                    );
                    if (sdata) {
                        setFormID(sdata.id);
                        const [detailRes, compTypeRes, eventRes] = await Promise.all([
                            schformdetail(sdata.id),
                            formcomptypelist(sdata.id),
                            eventsmasterlist()
                        ]);

                        if (detailRes.status === true) {
                            const form = detailRes.data.scholarship_form;
                            const startDate = new Date(form.form_entry_start_date);
                            const endDate = new Date(form.form_entry_end_date);
                            const today = new Date();

                            setIsFormOpen(today >= startDate && today <= endDate);
                            setFormDetails(form);
                        }

                        if (compTypeRes.status === true) {
                            setCList(compTypeRes.data.competition_types);
                        }

                        if (eventRes.status === true) {
                            setEList(eventRes.data);
                        }
                    }
                }

                if (sportsListRes.status === true) {
                    setSList(sportsListRes.data);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]); // include id if it can change

    // const handleChange = (e, index, field) => {
    //     if (index !== undefined) {
    //         const newAchievements = [...formData.achievements];
    //         newAchievements[index][field] =
    //             field === "certificate" ? e.target.files[0] : e.target.value;
    //         setFormData({ ...formData, achievements: newAchievements });
    //     } else {
    //         const { name, value } = e.target;
    //         setFormData({ ...formData, [name]: value });
    //     }
    // };
    const handleChange = (e, index, field) => {
        if (index !== undefined) {
            const newAchievements = [...formData.achievements];
            const value =
                field === "certificate" ? e.target.files[0] : e.target.value;

            // if (field === "comp_id") {
            //     const isDuplicate = newAchievements.some(
            //         (ach, i) => i !== index && ach.comp_id === value
            //     );

            //     if (isDuplicate) {
            //         toast.error("This competition type has already been selected!");
            //         return;
            //     }
            // }

            newAchievements[index][field] = value;
            setFormData({ ...formData, achievements: newAchievements });
        } else {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        }
    };


    const [formErrors, setFormErrors] = useState({
        mobileerr: "",
        emailerr: "",
    });

    function handleMobileBlur() {
        if (!formData.mobile) return;

        formmobilecheck(formid || "0", formData.mobile)
            .then((response) => {
                if (response.status === true && response.data?.valid === true) {
                    setFormErrors((prev) => ({ ...prev, mobileerr: "" }));
                } else {
                    setFormErrors((prev) => ({
                        ...prev,
                        mobileerr: response.data?.message || response.message || "Invalid mobile number",
                    }));
                }
            })

    };
    function handleEmailBlur() {
        if (!formData.email) return;

        formemailcheck(formid || "0", formData.email)
            .then((response) => {
                if (response.status === true && response.data?.valid === true) {
                    setFormErrors((prev) => ({ ...prev, emailerr: "" }));
                } else {
                    setFormErrors((prev) => ({
                        ...prev,
                        emailerr: response.data?.message || response.message || "Invalid Email",
                    }));
                }
            })

    };

    const addAchievement = () => {
        setFormData({
            ...formData,
            achievements: [
                ...formData.achievements,
                { comp_id: "", event_id: "", date: "", competition: "", position: "", score: "", certificate: null },
            ],
        });
    };

    const removeAchievement = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            achievements: prevData.achievements.filter((_, i) => i !== index),
        }));
    };

    // Add new reference
    const addReference = () => {
        setFormData({
            ...formData,
            referrences: [
                ...formData.referrences,
                { name: "", designation: "", mobile: "", email: "" },
            ],
        });
    };

    // Remove reference
    const removeReference = (index) => {
        setFormData((prevData) => ({
            ...prevData,
            referrences: prevData.referrences.filter((_, i) => i !== index),
        }));
    };

    // Handle change inside dynamic references
    const handleReferenceChange = (e, index, field) => {
        const { value } = e.target;
        const updatedReferences = [...formData.referrences];
        updatedReferences[index][field] = value;
        setFormData({ ...formData, referrences: updatedReferences });
    };
    const [fileErrors, setFileErrors] = useState({
        passportPhoto: "",
        idProof: "",
        bankPassbook: "",
        trainingPhoto: "",
    });

    const [showCropper, setShowCropper] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);

    const handlePassportFileChange = (e) => {
        const file = e.target.files[0];
        if (file && ["image/png", "image/jpeg"].includes(file.type)) {
            const reader = new FileReader();
            reader.onload = () => setImageSrc(reader.result);
            reader.readAsDataURL(file);
            setShowCropper(true);
        } else {
            setFileErrors((prev) => ({ ...prev, passportPhoto: "Only JPG or PNG allowed" }));
        }

        const reader = new FileReader();
        reader.onload = () => {
            setImageSrc(reader.result);
            setShowCropper(true);
        };
        reader.readAsDataURL(file);
    };

    const handleCropComplete = (croppedFile) => {
        // setFormData((prev) => ({
        //     ...prev,
        //     passportPhoto: croppedFile,
        // }));
        setFormPhoto(croppedFile);
        setFileErrors((prev) => ({ ...prev, passportPhoto: "" }));
        setImageSrc(null);
        setShowCropper(false);
    };
    const [incomeError, setIncomeError] = useState("");
    function handleProofIncomeUpload(event) {
        const file = event.target.files[0];
        setIncomeError("");
        setFormData({ ...formData, proofIncome: null });

        if (file) {
            const validFormats = /\.(jpg|jpeg|png|pdf)$/i;

            if (!file.name.match(validFormats)) {
                setIncomeError("File must be in JPG, JPEG, PNG, or PDF format.");
                return;
            }

            const sizeMB = file.size / 1024 / 1024;
            if (sizeMB > 5) {
                setIncomeError("File size must be less than 5MB.");
                return;
            }

            setFormData({ ...formData, proofIncome: file });
        }
    }

    const handleFileUpload = (e, fieldName) => {
        const file = e.target.files[0];
        const validTypes = ["image/png", "image/jpeg"];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!file) {
            setFileErrors((prev) => ({ ...prev, [fieldName]: "Please upload a file." }));
            return;
        }

        if (!validTypes.includes(file.type)) {
            setFileErrors((prev) => ({
                ...prev,
                [fieldName]: "Invalid file type. Only PNG or JPG allowed.",
            }));
            e.target.value = "";
            return;
        }

        if (file.size > maxSize) {
            setFileErrors((prev) => ({
                ...prev,
                [fieldName]: "File size exceeds 5MB.",
            }));
            e.target.value = "";
            return;
        }

        // ✅ If file is valid
        setFileErrors((prev) => ({ ...prev, [fieldName]: "" }));
        setFormData({
            ...formData,
            [fieldName]: file,
        });
    };
    const [errors, setErrors] = useState({});
    const handleRadioChange = (e) => {
        setFormData({
            ...formData,
            source: e.target.value,
            otherSource: "",
        });
        setErrors({ ...errors, source: "" });
    };

    const handleOtherChange = (e) => {
        setFormData({
            ...formData,
            otherSource: e.target.value,
        });
    };
    const handleAckChange = (e) => {
        setFormData({
            ...formData,
            acknowledge: e.target.value,
        });
        setErrors((prev) => ({ ...prev, acknowledge: "" }));
    };

    const prevStep = () => setStep(step - 1);

    // Add this validation function above your return()
    const validateStep1 = () => {
        setStep1Submit(true); // Trigger error messages

        const requiredFields = [
            "name",
            "dob",
            "gender",
            "permanentAddress",
            "communicationAddress",
            "mobile",
            "email",
            "education",
            "height",
            "weight",
        ];

        let valid = true;
        const newErrors = {};

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                valid = false;
            }
        });
        const mobileRegex = /^[0-9]{10}$/;
        if (formData.mobile && !mobileRegex.test(formData.mobile)) {
            valid = false;
            newErrors.mobile = "Mobile number must be exactly 10 digits";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.email && !emailRegex.test(formData.email)) {
            valid = false;
            newErrors.email = "Enter a valid email address";
        }
        if (formData.height && isNaN(formData.height)) {
            valid = false;
            newErrors.height = "Height must be a number";
        }

        if (formData.weight && isNaN(formData.weight)) {
            valid = false;
            newErrors.weight = "Weight must be a number";
        }
        if (formErrors.mobileerr) valid = false;
        if (formErrors.emailerr) valid = false;
        setErrors(newErrors);
        return valid;
    };
    const validateStep2 = () => {
        setStep2Submit(true); // Show validation messages
        let valid = true;

        // Required fields for this step
        const requiredFields = [
            "sport",
            "coachName",
            "coachMobile",
            "coachEmail",
            "coachDesgination",
            "coachQualification",
            "coachDescription",
        ];
        const newErrors = {};
        // Check basic required fields
        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                valid = false;
            }
        });
        const mobileRegex = /^[0-9]{10}$/;
        if (formData.coachMobile && !mobileRegex.test(formData.coachMobile)) {
            valid = false;
            newErrors.coachMobile = "Coach mobile number must be exactly 10 digits";
        }

        // Coach email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.coachEmail && !emailRegex.test(formData.coachEmail)) {
            valid = false;
            newErrors.coachEmail = "Enter a valid coach email address";
        }

        formData.achievements.forEach((ach, index) => {
            if (
                !ach.comp_id ||
                !ach.event_id ||
                !ach.date ||
                !ach.competition ||
                !ach.position ||
                !ach.score ||
                !ach.certificate
            ) {
                valid = false;
            }
        });
        setErrors(newErrors);
        return valid;
    };
    const validateStep3 = () => {
        setStep3Submit(true); // Show validation messages

        let valid = true;
        const newErrors = {};

        // Validate parents
        if (!formData.fatherName || formData.fatherName.trim() === "") {
            valid = false;
            newErrors.fatherName = "Father's name is required";
        }
        if (!formData.fatherOccu || formData.fatherOccu.trim() === "") {
            valid = false;
            newErrors.fatherOccu = "Father's occupation is required";
        }
        if (!formData.motherName || formData.motherName.trim() === "") {
            valid = false;
            newErrors.motherName = "Mother's name is required";
        }

        // Validate references
        if (formData.referrences.length === 0) {
            valid = false;
            newErrors.referrences = "At least one reference is required";
        }

        const mobileRegex = /^[0-9]{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        formData.referrences.forEach((ref, index) => {
            if (!ref.name || ref.name.trim() === "") {
                valid = false;
                newErrors[`ref_name_${index}`] = "Name is required";
            }
            if (!ref.designation || ref.designation.trim() === "") {
                valid = false;
                newErrors[`ref_designation_${index}`] = "Designation is required";
            }
            if (!ref.mobile || ref.mobile.trim() === "") {
                valid = false;
                newErrors[`ref_mobile_${index}`] = "Mobile number is required";
            } else if (!mobileRegex.test(ref.mobile)) {
                valid = false;
                newErrors[`ref_mobile_${index}`] = "Mobile number must be 10 digits";
            }
            // if (!ref.email || ref.email.trim() === "") {
            //     valid = false;
            //     newErrors[`ref_email_${index}`] = "Email is required";
            // } else 
            if (ref.email !== "" && !emailRegex.test(ref.email)) {
                valid = false;
                newErrors[`ref_email_${index}`] = "Enter a valid email address";
            }
        });

        setErrors(newErrors);
        return valid;
    };


    const nextStep = () => {
        if (step === 1) {
            if (validateStep1()) {
                setStep1Submit(false); // reset error display
                setStep(step + 1);
            }
        } else if (step === 2) {
            if (validateStep2()) {
                setStep2Submit(false);
                setStep(step + 1);
            }
        } else if (step === 3) {
            if (validateStep3()) {
                setStep3Submit(false);
                setStep(step + 1);
            }
        } else {
            setStep(step + 1);
        }
    };
    const validateStep4 = () => {
        let valid = true;

        const newFileErrors = { ...fileErrors };
        const newErrors = { source: "", otherSource: "", acknowledge: "" };
        if (!formphoto) {
            newFileErrors.passportPhoto = "This file is required.";
            valid = false;
        }
        // ✅ Check required files
        ["idProof", "bankPassbook", "trainingPhoto"].forEach((key) => {
            if (!formData[key]) {
                newFileErrors[key] = "This file is required.";
                valid = false;
            }
        });

        // ✅ Check source
        if (!formData.source) {
            newErrors.source = "Please select an option.";
            valid = false;
        }

        // ✅ Check otherSource if "Other"
        if (formData.source === "Other" && !formData.otherSource.trim()) {
            newErrors.otherSource = "Please specify this field.";
            valid = false;
        }

        // ✅ Check acknowledgement
        if (!formData.acknowledge) {
            newErrors.acknowledge = "Please confirm your acknowledgement.";
            valid = false;
        }

        setFileErrors(newFileErrors);
        setErrors(newErrors);
        return valid;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateStep4()) {
            setLoading(true);
            const formPayload = new FormData();
            // Personal Details
            formPayload.append("form_details_id", formid);
            formPayload.append("name", formData.name);
            formPayload.append("dob", formData.dob);
            formPayload.append("gender", formData.gender);
            formPayload.append("permanent_address", formData.permanentAddress);
            formPayload.append("communication_address", formData.communicationAddress);
            formPayload.append("mobile_number", formData.mobile);
            formPayload.append("email_id", formData.email);
            formPayload.append("highest_educational_qualification", formData.education);
            formPayload.append("height", formData.height);
            formPayload.append("weight", formData.weight);
            formPayload.append("medical_condition", formData.medicalCondition);
            const pdata = slist.find((item) => item.sports_cat_uid == formData.sport)
            // Sports Details
            formPayload.append("sport_id", formData.sport || "");
            formPayload.append("sport_name", pdata ? pdata.sports_category : '');
            formPayload.append("coach_name", formData.coachName);
            formPayload.append("coach_mobile_number", formData.coachMobile);
            formPayload.append("coach_email_id", formData.coachEmail);
            formPayload.append("coach_designation", formData.coachDesgination);
            formPayload.append("coach_qualification", formData.coachQualification);
            formPayload.append("coach_training_base", formData.coachDescription);

            // Family Details
            formPayload.append("father_name", formData.fatherName);
            formPayload.append("father_occupation", formData.fatherOccu);
            formPayload.append("mother_name", formData.motherName);
            formPayload.append("family_annual_income", formData.familyIncome);
            formPayload.append("proof_of_family_income", "-");//formData.proofIncome

            // References / Source
            formPayload.append("how_did_you_know_application", formData.source);
            formPayload.append("other_source", formData.otherSource);
            formPayload.append("form_status", 1);
            formPayload.append("created_by", 1);
            formPayload.append("updated_by", 1);
            formPayload.append("photograph", formphoto);
            //  formData.passportPhoto);
            formPayload.append("id_proof", formData.idProof);
            formPayload.append("bank_passbook_first_page", formData.bankPassbook);
            formPayload.append("photo_of_playing_sport", formData.trainingPhoto);
            formPayload.append("achievements_count", formData.achievements.length);
            formData.achievements.forEach((ach, index) => {
                formPayload.append(`competition_type_id_${index + 1}`, ach.comp_id);
                formPayload.append(`achievement_event_id_${index + 1}`, ach.event_id);
                formPayload.append(`date_of_competition_${index + 1}`, ach.date);
                formPayload.append(`competition_name_${index + 1}`, ach.competition);
                formPayload.append(`position_or_rank_${index + 1}`, ach.position);
                formPayload.append(`time_score_distance_${index + 1}`, ach.score);
                formPayload.append(`achievement_certificate_${index + 1}`, ach.certificate);
            });
            formPayload.append("references_count", formData.referrences.length);
            formData.referrences.forEach((ref, index) => {
                formPayload.append(`reference_name_${index + 1}`, ref.name);
                formPayload.append(`reference_designation_${index + 1}`, ref.designation);
                formPayload.append(`reference_mobile_no_${index + 1}`, ref.mobile);
                formPayload.append(`reference_email_id_${index + 1}`, ref.email);
            });
            dotracking("submit button in registered form for " + formData.name + " for form - (" + formid + ") $$ " + trackobj.formregheading);

            formregsave(formPayload).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    setIsFormOpen(false);
                    setSucMsg(true);
                    toast.success(res.message);
                } else {
                    setLoading(false)
                    toast.error(res.data.message)
                }
            })
        }
    };

    return (
        <div id="athletescholar"
            style={{
                backgroundColor: "#0d47a1",
                minHeight: "100vh",
                padding: "40px",
                color: "white",
            }}
        >
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {/* ===== Step 0: Intro Modal ===== */}
            <Modal show={showModal} centered size="xl">
                <Modal.Header style={{ backgroundColor: "#f5f5f5", justifyContent: "center" }}>
                    <Modal.Title
                        style={{
                            color: "#0d47a1",
                            fontSize: "24px",    
                            textAlign: "center", 
                            width: "100%" 
                        }}
                    >
                        {formDetails?.form_name}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                    <div
                        className="form-info-container"
                        dangerouslySetInnerHTML={{ __html: formDetails?.form_info_content }}
                    />
                    {/* <h3 className="text-center" style={{ color: "#0d47a1" }}>
                        Sportz Village Foundation Athlete Scholarships – PathwayZ36
                    </h3>
                    <p>
                        <strong>Sportz Village Foundation Athlete Scholarships / स्पोर्ट्ज विलेज फाउंडेशन एथलीट स्कॉलरशिप्स</strong><br />
                        Sportz Village Foundation is the non-profit subsidiary of India's largest sports education organization Sportz Village, which for the last two decades has been helping children from public schools (rural & urban) benefit from sports and physical education programs for improved developmental outcomes.
                    </p>

                    <p>
                        Sportz Village Foundation through its PathwayZ36 program is looking for talented, passionate, and goal-driven athletes who have demonstrated exceptional skill and resolve to achieve significant milestones in their sporting careers.
                    </p>

                    <p>स्पोर्ट्ज़ विलेज फाउंडेशन भारत के सबसे बड़े खेल शिक्षा संगठन स्पोर्ट्ज़ विलेज की गैर-लाभकारी सहायक कंपनी है, जो पिछले दो दशकों से सार्वजनिक स्कूलों (ग्रामीण और शहरी) के बच्चों को बेहतर विकासात्मक परिणामों के लिए खेल और शारीरिक शिक्षा कार्यक्रमों से लाभान्वित करने में मदद कर रही है।
                    </p>
                    <p>स्पोर्टज़ विलेज फाउंडेशन अपने PathwayZ36 कार्यक्रम के माध्यम से प्रतिभाशाली, भावुक और लक्ष्य-संचालित एथलीटों की तलाश कर रहा है, जिन्होंने अपने खेल करियर में महत्वपूर्ण मील के पत्थर हासिल करने के लिए असाधारण कौशल और संकल्प का प्रदर्शन किया है।
                    </p>

                    <hr />
                    <h5>Support Structure / सहयोग संरचना</h5>
                    <p>
                        Athletes selected under the Scholarship Program will be offered crucial support by the Sportz Village Foundation towards achieving their sporting goals. The support structure will be broadly directed towards:
                    </p>
                    <ul className="custom-bullets">
                        <li>Training and Development</li>
                        <li>Competitions</li>
                        <li>Mentorship</li>
                        <li>High-Performance Stints</li>
                        <li>Sports Science</li>
                        <li>Career Guidance</li>
                        <li>Knowledge Building Workshops and Seminars</li>
                    </ul>
                    <br />
                    <p>
                        छात्रवृत्ति कार्यक्रम के तहत चयनित एथलीटों को उनके खेल लक्ष्यों को प्राप्त करने के लिए स्पोर्ट्ज विलेज फाउंडेशन द्वारा महत्वपूर्ण समर्थन प्राप्त होगा। यह समर्थन मुख्य रूप से निम्नलिखित क्षेत्रों में निर्देशित होगा:
                    </p>
                    <ul className="custom-bullets">
                        <li>प्रशिक्षण एवं विकास</li>
                        <li>प्रतियोगिताएं</li>
                        <li>मार्गदर्शन</li>
                        <li>उच्च प्रदर्शन के लिए कार्यक्रम</li>
                        <li>स्पोर्ट्स साइंस</li>
                        <li>कैरियर मार्गदर्शन</li>
                        <li>ज्ञान निर्माण कार्यशालाएं और सेमिनार</li>
                    </ul>

                    <hr />
                    <h5>Selection Criteria / चयन करने का मापदंड</h5>
                    <p>
                        For the Sportz Village Foundation Athlete Scholarships, we are looking for Indian athletes with extraordinary talent who have demonstrated the highest levels of commitment, passion, integrity, and ethics to achieve success; athletes whose continued success can inspire others to excel.
                    </p>
                    <p>
                        If you are an Indian athlete competing in any Olympic discipline/any other sport and meet the following criteria:
                    </p>
                    <ul className="custom-bullets">
                        <li>Age criteria - Open</li>
                        <li>With medals at the National level in your age category or higher</li>
                        <li>With a potential to win medals for India at the international stage. Turn overleaf and apply now!</li>
                    </ul>
                    <p>If you get any queries in the interim/face any issues while filling the application form, please write to us at <a className="text-info font-weight-bold">pathwayzscholarships@sportzvillage.com</a>. If you are not an athlete but know someone who fulfills the above-mentioned criteria, feel free to direct the Application Form and encourage them to apply.</p>

                    <p>
                        Make sure you have a scanned copy of the below documents ready (maximum allowed file size per document is 10 MB, allowed file formats: Document, Image, and PDF):
                    </p>
                    <ul className="custom-bullets">
                        <li>Passport size photo</li>
                        <li>Any one Govt.-approved Photo ID proof (Passport, Aadhaar Card)</li>
                        <li>Bank Passbook 1st page</li>
                        <li>Certificates of any five major national/international achievements</li>
                        <li>Full-size pictures of the applicant while training or playing sport</li>
                    </ul>

                    <p>स्पोर्ट्ज़ विलेज फाउंडेशन एथलीट स्कॉलरशिप के लिए हम असाधारण योग्यता वाले भारतीय एथलीटों की तलाश कर रहे हैं जिन्होंने सफलता प्राप्त करने के लिए प्रतिबद्धता, जुनून, ईमानदारी और नैतिकता के उच्चतम स्तर का प्रदर्शन किया है; एथलीट्स जिनकी निरंतर सफलता दूसरों को उत्कृष्टता के लिए प्रेरित कर सकती है।
                    </p>
                    <p>
                        यदि आप किसी ओलंपिक के अधीन स्पोर्ट या किसी अन्य खेल में प्रतिस्पर्धा खेलने वाले भारतीय एथलीट हैं और निचे दिए मापदंडों को पूरा कर रहे है तो
                    </p>
                    <ul className="custom-bullets">
                        <li>आयु मानदंड - सभी आयु वर्ग के एथलिट के लिए</li>
                        <li>अपनी आयु वर्ग या उच्चतर वर्ग में राष्ट्रीय स्तर पर पदक हासिल किया हो</li>
                        <li>अंतर्राष्ट्रीय स्तर पर भारत के लिए पदक जीतने की क्षमता हो</li>
                    </ul>
                    <p>आगे बढ़े और आवेदन करें|</p>
                    <p>यदि आपको आवेदन पत्र भरते समय किसी भी परेशानी सामना करना पड़ता है, तो कृपया हमें <a className="text-info font-weight-bold">pathwayzscholarships@sportzvillage.com</a> पर ईमेल लिखें। यदि आप एक एथलीट नहीं हैं लेकिन किसी ऐसे व्यक्ति को जानते हैं जो उपर्युक्त मानदंडों को पूरा करता है तो आवेदन पत्र को निर्देशित करें और उन्हें इस फॉर्म को भरने के लिए प्रोत्साहित करें|
                    </p>
                    <p>
                        सुनिश्चित करें कि नीचे दिए गए दस्तावेज़ आपके पास हैं (प्रत्येक दस्तवेज का अधिकतम फ़ाइल साइज 10 MB है;  इन फ़ाइल स्वरूपों की अनुमति दी गयी है- Document, Image, and PDF):
                    </p>
                    <ul className="custom-bullets">
                        <li>पासपोर्ट साइज फोटो</li>
                        <li>सरकारी फोटो आईडी प्रूफ (पासपोर्ट, आधार कार्ड)</li>
                        <li>बैंक पासबुक 1 पेज</li>
                        <li>किसी भी पांच प्रमुख राष्ट्रीय/अंतर्राष्ट्रीय उपलब्धियों का प्रमाण पत्र</li>
                        <li>ट्रेनिंग या खेलते समय का फुल साइज फोटो</li>
                    </ul> */}
                </Modal.Body>

                <Modal.Footer>

                    <Button variant="success" onClick={() => { setShowModal(false); setStep(1) }}>
                        Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* ===== Step 1+: Main Form ===== */}
            {!showModal && !loading && sucmsg ? (
                <div
                    style={{
                        textAlign: "center",
                        marginTop: "20%",
                        fontSize: "24px",
                        color: "yellow",
                    }}
                >
                    Your application has been submitted successfully.
                    <br />
                    आपका आवेदन सफलतापूर्वक सबमिट हो गया है
                    <br />
                    <span>An email has been sent it to your registered email <br />आपके पंजीकृत ईमेल पर एक ईमेल भेज दिया गया है।</span>
                </div>
            ) : !showModal && !loading && !sucmsg && isFormOpen ? (
                <Container>
                    <Card className="p-4 shadow-lg" style={{ borderRadius: "16px" }}>
                        <Card.Header><h4>{formDetails?.form_name}</h4></Card.Header>
                        <Card.Body>
                            {/* === CUSTOM HEADER PROGRESS === */}
                            <div className="step-header mb-4">
                                <div className={`step-tab ${step === 1 ? "active" : ""}`}>
                                    Personel Details
                                </div>
                                <div className={`step-tab ${step === 2 ? "active" : ""}`}>
                                    Sports Details
                                </div>
                                <div className={`step-tab ${step === 3 ? "active" : ""}`}>
                                    Family Details
                                </div>
                                <div className={`step-tab ${step === 4 ? "active" : ""}`}>
                                    Documents
                                </div>
                            </div>

                            <h3 className="text-center text-primary mb-4">
                                Application Form / आवेदन पत्र
                            </h3>

                            <Form onSubmit={handleSubmit}>
                                {/* ================= STEP 1 ================= */}
                                {step === 1 && (
                                    <>
                                        <h6 className="text-secondary mb-3">Personal Details</h6>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-user"></i> Name (as per official document)/नाम (सरकारी पहचान पत्र के अनुसार) <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter full name"
                                                        name="name"
                                                        required
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    />
                                                    {step1submit && !formData.name && (
                                                        <span className="text-danger">Name is required</span>
                                                    )}
                                                </div></div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-calendar"></i> Date of Birth/जन्म तिथि <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="date"
                                                        name="dob"
                                                        required
                                                        value={formData.dob}
                                                        onChange={handleChange}
                                                    />
                                                    {step1submit && !formData.dob && (
                                                        <span className="text-danger">Date of birth is required</span>
                                                    )}
                                                </div></div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-venus-mars"></i> Gender/लिंग <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        name="gender"
                                                        required
                                                        value={formData.gender}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Gender</option>
                                                        <option>Male</option>
                                                        <option>Female</option>
                                                        <option>Other</option>
                                                    </select>
                                                    {step1submit && !formData.gender && (
                                                        <span className="text-danger">Gender is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-map-location-dot"></i> Permanent Address/स्थाई पता <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="permanentAddress"
                                                        placeholder="Enter permanent address"
                                                        value={formData.permanentAddress}
                                                        onChange={handleChange}
                                                    />
                                                    {step1submit && !formData.permanentAddress && (
                                                        <span className="text-danger">Permanent Address is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-map-pin"></i> Communication Address/संचार पता <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="communicationAddress"
                                                        placeholder="Enter communication address"
                                                        value={formData.communicationAddress}
                                                        onChange={handleChange}
                                                    />
                                                    {step1submit && !formData.communicationAddress && (
                                                        <span className="text-danger">Communication Address is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-phone"></i> Mobile number/मोबाइल नंबर <span className="text-danger">* </span> <span className="text-desc">( Enter your mobile number. Do not prefix 0 or +91./१० अंक के मोबाइल नंबर को लिखे I 0 या +91 मोबाइल नंबर के शुरुआत में न जोड़े I )</span>
                                                    </label>
                                                    <input
                                                        type="tel"
                                                        name="mobile"
                                                        placeholder="Enter mobile number"
                                                        value={formData.mobile}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, "");
                                                            handleChange({ target: { name: "mobile", value } });
                                                        }}
                                                        onBlur={handleMobileBlur}
                                                        maxLength={10}
                                                    />
                                                    {step1submit && (errors.mobile || !formData.mobile) && (
                                                        <span className="text-danger">
                                                            {errors.mobile || "Mobile Number is required"}
                                                        </span>
                                                    )}
                                                    {formErrors.mobileerr &&
                                                        <span className="text-danger">{formErrors.mobileerr}</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-envelope"></i> Email ID/ईमेल आईडी <span className="text-danger">* </span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Enter email address"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        onBlur={handleEmailBlur}
                                                    />
                                                    {step1submit && (errors.email || !formData.email) && (
                                                        <span className="text-danger">
                                                            {errors.email || "Email ID is required"}
                                                        </span>
                                                    )}
                                                    {formErrors.emailerr &&
                                                        <span className="text-danger">{formErrors.emailerr}</span>
                                                    }
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-graduation-cap"></i> Highest Educational Qualification/उच्चतम शैक्षिक  योग्यता <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="education"
                                                        placeholder="Enter qualification"
                                                        value={formData.education}
                                                        onChange={handleChange}
                                                    />
                                                    {step1submit && !formData.education && (
                                                        <span className="text-danger">Highest Educational Qualification is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-ruler-vertical"></i> Height (in cm)/कद (cm में ) <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        name="height"
                                                        placeholder="Enter height in cm"
                                                        value={formData.height}
                                                        onChange={handleChange}
                                                        maxLength={6}
                                                    />
                                                    {step1submit && (errors.height || !formData.height) && (
                                                        <span className="text-danger">
                                                            {errors.height || "Height is required"}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-weight-scale"></i> Weight (in Kg)/वजन (kg  में ) <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        name="weight"
                                                        placeholder="Enter weight in kg"
                                                        value={formData.weight}
                                                        onChange={handleChange}
                                                        maxLength={6}
                                                    />
                                                    {step1submit && (errors.weight || !formData.weight) && (
                                                        <span className="text-danger">
                                                            {errors.weight || "Weight is required"}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-align-left"></i> Medical Condition (If any)/स्वास्थ्य में कोई समस्या (यदि हो तो )
                                                    </label>
                                                    <textarea
                                                        rows="2"
                                                        name="medicalCondition"
                                                        placeholder="Enter medical condition"
                                                        value={formData.medicalCondition}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-right mt-4">
                                            <button
                                                className="btn btn-danger"
                                                type="button"
                                                onClick={nextStep}
                                            >
                                                Next <i className="fa-solid fa-arrow-right"></i>
                                            </button>
                                        </div>




                                    </>
                                )}

                                {/* ================= STEP 2 ================= */}
                                {step === 2 && (
                                    <>
                                        <h6 className="text-secondary mb-3">SPORT DETAILS/स्पोर्ट्स का विवरण</h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-basketball"></i> Sport/स्पोर्ट <span className="text-danger"> *</span>
                                                    </label>
                                                    <select name="sport"
                                                        value={formData.sport}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-- Select Sport --</option>
                                                        {/* {slist && slist.length > 0 &&
                                                            slist
                                                                .filter(item => item.sports_cat_uid === 16) // ✅ only items with sports_cat_uid = 16
                                                                .map((item, index) => (
                                                                    <option key={index} value={item.sports_cat_uid}>
                                                                        {item.sports_category}
                                                                    </option>
                                                                ))
                                                        } */}

                                                        {slist && slist.length > 0 &&
                                                            slist.map((item, index) => (
                                                                <option key={index} value={item.sports_cat_uid}>
                                                                    {item.sports_category}
                                                                </option>
                                                            ))
                                                        }
                                                    </select>

                                                    {step2submit && !formData.sport && (
                                                        <span className="text-danger">Sport is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-user-tie"></i> Name of the Coach/कोच का नाम <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="coachName"
                                                        placeholder="Enter coach name"
                                                        required
                                                        value={formData.coachName}
                                                        onChange={handleChange}
                                                    />
                                                    {step2submit && !formData.coachName && (
                                                        <span className="text-danger">Coach name is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-phone"></i> Coach's mobile number/कोच का मोबाइल नंबर <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="tel"
                                                        name="coachMobile"
                                                        placeholder="Enter coach mobile number"
                                                        required
                                                        value={formData.coachMobile}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, "");
                                                            handleChange({ target: { name: "coachMobile", value } });
                                                        }}
                                                        maxLength={10}
                                                    />

                                                    {step2submit && (errors.coachMobile || !formData.coachMobile) && (
                                                        <span className="text-danger">
                                                            {errors.coachMobile || "Coach mobile number is required"}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-envelope"></i> Email id (Coach)/कोच का ईमेल आईडी <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        name="coachEmail"
                                                        placeholder="Enter coach email"
                                                        value={formData.coachEmail}
                                                        onChange={handleChange}
                                                    />

                                                    {step2submit && (errors.coachEmail || !formData.coachEmail) && (
                                                        <span className="text-danger">
                                                            {errors.coachEmail || "Coach email is required"}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-graduation-cap"></i> Designation of the Coach/कोच का पद <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="coachDesgination"
                                                        placeholder="Enter coach designation"
                                                        value={formData.coachDesgination}
                                                        onChange={handleChange}
                                                    />
                                                    {step2submit && !formData.coachDesgination && (
                                                        <span className="text-danger">Designation is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-graduation-cap"></i> Qualification of the Coach/कोच का क्वालिफिकेशन <span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="coachQualification"
                                                        placeholder="Enter coach qualification"
                                                        value={formData.coachQualification}
                                                        onChange={handleChange}
                                                    />
                                                    {step2submit && !formData.coachQualification && (
                                                        <span className="text-danger">Qualification is required</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-align-left"></i> Training Base (Name and Location)/ट्रेनिंग बेस (नाम और पता) <span className="text-danger"> *</span>
                                                    </label>
                                                    <textarea
                                                        rows="2"
                                                        name="coachDescription"
                                                        placeholder="Enter training base"
                                                        value={formData.coachDescription}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                    {step2submit && !formData.coachDescription && (
                                                        <span className="text-danger">Training Base is required</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="text-secondary mb-0">
                                                ACHIEVEMENTS (ANY THREE MAJOR - NATIONAL &/OR INTERNATIONAL) /
                                                उपलब्धियां (सर्वश्रेष्ठ 3 - नेशनल या इंटरनेशनल)
                                            </h6>
                                            {formData.achievements.length < 5 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={addAchievement}
                                                    disabled={formData.achievements.length >= 5}
                                                >
                                                    + Add Another Achievement
                                                </button>
                                            )}
                                        </div>

                                        {/* ====== ACHIEVEMENTS LIST ====== */}
                                        {formData.achievements.map((ach, i) => (
                                            <div key={i} className="row p-3 border rounded mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h4 className="mb-0">Achievement {i + 1}</h4>
                                                    {formData.achievements.length > 1 && i != 0 &&
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeAchievement(i)}
                                                        >
                                                            <i className="fa-solid fa-trash"></i> Remove
                                                        </button>
                                                    }

                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-medal"></i> Competition Type/प्रतियोगिता का प्रकार <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            value={ach.comp_id || ""}
                                                            onChange={(e) => handleChange(e, i, "comp_id")}
                                                        >
                                                            <option value="">-- Select Competition Type --</option>
                                                            {clist && clist.length > 0 &&
                                                                clist.map((item, index) => (
                                                                    <option key={index} value={item.id}>
                                                                        {item.competition_type}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                        {step2submit && !ach.comp_id && <span className="text-danger">Competition Type is required</span>}

                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-medal"></i> Event Type/प्रतियोगिता का प्रकार <span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            value={ach.event_id || ""}
                                                            onChange={(e) => handleChange(e, i, "event_id")}
                                                        >
                                                            <option value="">-- Select Event Type --</option>
                                                            {elist && elist.length > 0 &&
                                                                elist.map((item, index) => (
                                                                    <option key={index} value={item.event_uid}>
                                                                        {item.event_name}
                                                                    </option>
                                                                ))
                                                            }
                                                        </select>
                                                        {step2submit && !ach.event_id && <span className="text-danger">Event Type is required</span>}

                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-calendar"></i> Date of the competition/प्रतियोगिता की तारीख <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            value={ach.date}
                                                            onChange={(e) => handleChange(e, i, "date")}
                                                        />
                                                        {step2submit && !ach.date && <span className="text-danger">Date is required</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-trophy"></i> Competition Name/प्रतियोगिता का नाम <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter competition name"
                                                            value={ach.competition}
                                                            onChange={(e) => handleChange(e, i, "competition")}
                                                        />
                                                        {step2submit && !ach.competition && <span className="text-danger">Competition name is required</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-ranking-star"></i> Position/Rank/प्रतियोगिता में स्थान <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="number"
                                                            placeholder="Enter position/rank"
                                                            value={ach.position}
                                                            onChange={(e) => handleChange(e, i, "position")}
                                                        />
                                                        {step2submit && !ach.position && <span className="text-danger">Position/Rank is required</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-stopwatch"></i> Time/Score/Distance/टाइम/स्कोर/दूरी <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter time, score, or distance"
                                                            value={ach.score}
                                                            onChange={(e) => handleChange(e, i, "score")}
                                                        />
                                                        {step2submit && !ach.score && <span className="text-danger">Score/Time/Distance is required</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-file-upload"></i> Upload the certificate/सर्टिफिकेट अपलोड करे <span className="text-danger"> *</span><br /><span className="text-desc">(Formats like png, jpg, jpeg, pdf only, Size: 5MB)</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            onChange={(e) => handleChange(e, i, "certificate")}
                                                            accept=".png,.jpg,.jpeg,.pdf"
                                                        />
                                                        {step2submit && !ach.certificate && <span className="text-danger">Certificate upload is required</span>}

                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        ))}



                                        <div className="d-flex justify-content-between mt-4">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                onClick={prevStep}
                                            >
                                                <i className="fa-solid fa-arrow-left"></i> Previous
                                            </button>

                                            <button
                                                className="btn btn-danger"
                                                type="button"
                                                onClick={nextStep}
                                            >
                                                Next <i className="fa-solid fa-arrow-right"></i>
                                            </button>
                                        </div>

                                    </>
                                )}
                                {step === 3 && (
                                    <>
                                        <h6 className="text-secondary mb-3">FAMILY DETAILS / परिवार का विवरण</h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-user-tie"></i> Father's Name/पिता का नाम <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="fatherName"
                                                        placeholder="Enter father's name"
                                                        value={formData.fatherName}
                                                        onChange={handleChange}
                                                    />
                                                    {step3submit && !formData.fatherName && (
                                                        <span className="text-danger">Father name is required</span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-briefcase"></i> Father's Occupation/पिता का रोजगार <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="fatherOccu"
                                                        placeholder="Enter father's occupation"
                                                        value={formData.fatherOccu}
                                                        onChange={handleChange}
                                                    />
                                                    {step3submit && !formData.fatherOccu && (
                                                        <span className="text-danger">Father occupation is required</span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-user"></i> Mother's Name/माता का नाम <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="motherName"
                                                        placeholder="Enter mother's name"
                                                        value={formData.motherName}
                                                        onChange={handleChange}
                                                    />
                                                    {step3submit && !formData.motherName && (
                                                        <span className="text-danger">Mother name is required</span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-money-bill-wave"></i> Family Annual Income/परिवार की वार्षिक आय
                                                        {/* <span className="text-danger">*</span> */}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="familyIncome"
                                                        placeholder="Enter family income"
                                                        value={formData.familyIncome}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            {/* <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-file-upload"></i> Proof of Family Annual Income/परिवार की वार्षिक आय का प्रमाण
                                                        <span className="text-desc">(Formats: png, jpg, jpeg, pdf, Max: 5MB)</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="proofIncome"
                                                        placeholder="Enter proof of family income"
                                                        value={formData.proofIncome}
                                                        onChange={handleChange}
                                                    />
                                                    <input
                                                        type="file"
                                                        name="proofIncome"
                                                        accept=".png,.jpg,.jpeg,.pdf"
                                                        onChange={handleProofIncomeUpload}
                                                    />
                                                    {incomeError && <p className="text-danger">{incomeError}</p>}
                                                </div>
                                            </div> */}
                                        </div>




                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h6 className="text-secondary mb-0">
                                                REFERENCES/सिफारिशों का विवरण
                                            </h6>
                                            {formData.referrences.length < 5 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={addReference}
                                                >
                                                    + Add Reference
                                                </button>
                                            )}
                                        </div>

                                        {formData.referrences.map((ref, i) => (
                                            <div key={i} className="row p-3 border rounded mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 className="mb-0">Reference {i + 1} / सिफारिश {i + 1}</h5>
                                                    {formData.referrences.length > 1 && i != 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeReference(i)}
                                                        >
                                                            <i className="fa-solid fa-trash"></i> Remove
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-user"></i> Name/नाम <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter name"
                                                            value={ref.name}
                                                            onChange={(e) => handleReferenceChange(e, i, "name")}
                                                        />
                                                        {step3submit && errors[`ref_name_${i}`] && <span className="text-danger">{errors[`ref_name_${i}`]}</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-id-badge"></i> Designation/पद <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter designation"
                                                            value={ref.designation}
                                                            onChange={(e) => handleReferenceChange(e, i, "designation")}
                                                        />
                                                        {step3submit && errors[`ref_designation_${i}`] && <span className="text-danger">{errors[`ref_designation_${i}`]}</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-phone"></i> Mobile Number/मोबाइल नंबर <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="tel"
                                                            placeholder="Enter mobile number"
                                                            value={ref.mobile}
                                                            maxLength={10}
                                                            // onChange={(e) => handleReferenceChange(e, i, "mobile")}
                                                            onChange={(e) => {
                                                                const onlyNums = e.target.value.replace(/\D/g, "");
                                                                handleReferenceChange({ target: { value: onlyNums } }, i, "mobile");
                                                            }}
                                                        />
                                                        {step3submit && errors[`ref_mobile_${i}`] && <span className="text-danger">{errors[`ref_mobile_${i}`]}</span>}

                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="input-field">
                                                        <label>
                                                            <i className="fa-solid fa-envelope"></i> Email ID/ईमेल आईडी (Optional)
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <input
                                                            type="email"
                                                            placeholder="Enter email"
                                                            value={ref.email}
                                                            onChange={(e) => handleReferenceChange(e, i, "email")}
                                                        />
                                                        {/* {step3submit && errors[`ref_email_${i}`] && <span className="text-danger">{errors[`ref_email_${i}`]}</span>} */}

                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        ))}




                                        <div className="d-flex justify-content-between mt-4">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                onClick={prevStep}
                                            >
                                                <i className="fa-solid fa-arrow-left"></i> Previous
                                            </button>

                                            <button
                                                className="btn btn-danger"
                                                type="button"
                                                onClick={nextStep}
                                            >
                                                Next <i className="fa-solid fa-arrow-right"></i>
                                            </button>
                                        </div>


                                    </>
                                )}
                                {step === 4 && (
                                    <>
                                        <h6 className="text-secondary mb-3">REQUIRED DOCUMENTS/अपेक्षित दस्तावेज </h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-image"></i> Passport Size Photograph / पासपोर्ट साइज फोटो
                                                        <span className="text-danger"> *</span><br />
                                                        <span className="text-desc">(Only PNG, JPG formats. Max size: 5MB)</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".png,.jpg,.jpeg"
                                                        onChange={handlePassportFileChange}
                                                    />
                                                    {fileErrors.passportPhoto && (
                                                        <span className="text-danger" >
                                                            {fileErrors.passportPhoto}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            {showCropper && (
                                                <ImageCropperModal
                                                    imageSrc={imageSrc}
                                                    onCancel={() => setShowCropper(false)}
                                                    onCropComplete={handleCropComplete}

                                                />
                                            )}
                                            {/* {imageSrc && !showCropper && (
                                                <div className="image-preview" style={{ marginTop: "10px" }}>
                                                    <img
                                                        src={imageSrc}
                                                        alt="Preview"
                                                        style={{ maxWidth: "200px", maxHeight: "200px" }}
                                                    />
                                                </div>
                                            )} */}
                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-id-card"></i> Any one Government approved ID proof / कोई भी सरकारी स्वीकृत आईडी कार्ड
                                                        <span className="text-danger"> *</span><br />
                                                        <span className="text-desc">(Only PNG, JPG formats. Max size: 5MB)</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".png,.jpg,.jpeg"
                                                        onChange={(e) => handleFileUpload(e, "idProof")}
                                                    />
                                                    {fileErrors.idProof && (
                                                        <span className="text-danger" >
                                                            {fileErrors.idProof}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-book"></i> Bank Passbook First Page (Upload) / बैंक पासबुक का पहला पेज (अपलोड करें)
                                                        <span className="text-danger"> *</span><br />
                                                        <span className="text-desc">(Only PNG, JPG formats. Max size: 5MB)</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".png,.jpg,.jpeg"
                                                        onChange={(e) => handleFileUpload(e, "bankPassbook")}
                                                    />
                                                    {fileErrors.bankPassbook && (
                                                        <span className="text-danger" >
                                                            {fileErrors.bankPassbook}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="input-field">
                                                    <label>
                                                        <i className="fa-solid fa-person-running"></i> Full-size photograph of the athlete while training or playing sport (Upload) / खिलाड़ी के ट्रेनिंग के दौरान का फुल साइज फोटो (अपलोड करें)
                                                        <span className="text-danger"> *</span><br />
                                                        <span className="text-desc">(Only PNG, JPG formats. Max size: 5MB)</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".png,.jpg,.jpeg"
                                                        onChange={(e) => handleFileUpload(e, "trainingPhoto")}
                                                    />
                                                    {fileErrors.trainingPhoto && (
                                                        <span className="text-danger" >
                                                            {fileErrors.trainingPhoto}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                        <hr />
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <label className="mb-2">
                                                    <i className="fa-solid fa-question-circle"></i> HOW DID YOU COME ACROSS THIS APPLICATION FORM /
                                                    आपको छात्रवृत्ति के बारे में कैसे पता चला <span className="text-danger"> *</span>
                                                </label>

                                                <div className=" mt-2">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id="option1"
                                                            name="source"
                                                            value="Directly through email from Sportz Village Foundation"
                                                            checked={formData.source === "Directly through email from Sportz Village Foundation"}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="option1">
                                                            Directly through email from Sportz Village Foundation /
                                                            स्पोर्ट्ज़ विलेज फाउंडेशन के ईमेल के द्वारा
                                                        </label>
                                                    </div>

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id="option2"
                                                            name="source"
                                                            value="Sportz Village Foundation Social Media (Facebook, Twitter, etc.)"
                                                            checked={formData.source === "Sportz Village Foundation Social Media (Facebook, Twitter, etc.)"}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="option2">
                                                            Sportz Village Foundation Social Media (Facebook, Twitter, etc.) /
                                                            स्पोर्ट्ज़ विलेज फाउंडेशन के सोशल मीडिया जैसे फेसबुक, ट्विटर इत्यादि के द्वारा
                                                        </label>
                                                    </div>

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id="option3"
                                                            name="source"
                                                            value="Sportz Village Foundation Website"
                                                            checked={formData.source === "Sportz Village Foundation Website"}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="option3">
                                                            Sportz Village Foundation Website /
                                                            स्पोर्ट्ज़ विलेज फाउंडेशन के वेबसाइट के द्वारा
                                                        </label>
                                                    </div>

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id="option4"
                                                            name="source"
                                                            value="Media (Digital or Print)"
                                                            checked={formData.source === "Media (Digital or Print)"}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="option4">
                                                            Media (Digital or Print) / मीडिया (डिजिटल या प्रिंट)
                                                        </label>
                                                    </div>

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            id="option5"
                                                            name="source"
                                                            value="Other"
                                                            checked={formData.source === "Other"}
                                                            onChange={handleRadioChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="option5">
                                                            Other / अन्य
                                                        </label>
                                                    </div>
                                                </div>

                                                {errors.source && <span className="text-danger">{errors.source}</span>}

                                                {formData.source === "Other" && (
                                                    <div className="mt-2">
                                                        <input
                                                            type="text"
                                                            name="otherSource"
                                                            placeholder="Please specify / कृपया विवरण दर्ज करें"
                                                            value={formData.otherSource}
                                                            onChange={handleOtherChange}
                                                        />
                                                        {errors.otherSource && (
                                                            <span className="text-danger">{errors.otherSource}</span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="input-field">
                                            <label className="ack-heading">
                                                <i className="fa-solid fa-clipboard-check"></i> ACKNOWLEDGEMENT / प्राप्ति सूचना <span className="text-danger">*</span>
                                            </label>

                                            <div className="ack-text">
                                                <p>
                                                    I agree and acknowledge that the submission of this form does not in
                                                    any manner guarantee my selection for the Sportz Village Foundation
                                                    Athlete Scholarship, and that the Sportz Village Foundation reserves
                                                    the right to accept or reject my application. Further, I hereby
                                                    certify that the information provided by me herein is complete,
                                                    accurate and true in all respect and Sportz Village Foundation is
                                                    free to verify such information directly or through third parties.
                                                </p>
                                                <p>
                                                    I am aware that I am applying for selection to the Sportz Village
                                                    Foundation Athlete Scholarship. Sportz Village Foundation may, at
                                                    its discretion, consider my application for support through any of
                                                    its schemes/programs.
                                                </p>

                                                <hr />

                                                <p>
                                                    मैं सहमत हूं और स्वीकार करता हूं कि इस फॉर्म को जमा करना किसी भी तरह से
                                                    स्पोर्टज़ विलेज फाउंडेशन एथलीट छात्रवृत्ति के लिए मेरे चयन की गारंटी नहीं
                                                    देता है, और स्पोर्ट्ज़ विलेज फाउंडेशन मेरे आवेदन को स्वीकार या अस्वीकार
                                                    करने का अधिकार सुरक्षित रखता है। इसके अलावा, मैं प्रमाणित करता हूं कि यहां
                                                    मेरे द्वारा प्रदान की गई जानकारी सभी मामलों में पूर्ण, सटीक और सत्य है और
                                                    स्पोर्टज़ विलेज फाउंडेशन ऐसी जानकारी को सीधे या तीसरे पक्ष के माध्यम से
                                                    सत्यापित करने के लिए स्वतंत्र है।
                                                </p>
                                                <p>
                                                    मुझे पता है कि मैं स्पोर्ट्ज़ विलेज फाउंडेशन एथलीट स्कॉलरशिप में चयन के लिए
                                                    आवेदन कर रहा हूं। स्पोर्ट्ज़ विलेज फाउंडेशन, अपने विवेक से, अपनी किसी भी
                                                    योजना/कार्यक्रम के माध्यम से समर्थन के लिए मेरे आवेदन पर विचार कर सकता है।
                                                </p>
                                            </div>

                                            <div className="radio-section mt-3">
                                                <label className="radio-label">
                                                    I agree / मैं सहमत हूं <span className="text-danger">*</span>
                                                </label>

                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="agreeYes"
                                                        name="acknowledge"
                                                        value="Yes"
                                                        checked={formData.acknowledge === "Yes"}
                                                        onChange={handleAckChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="agreeYes">
                                                        Yes / हां
                                                    </label>
                                                </div>

                                                {errors.acknowledge && (
                                                    <span className="text-danger">{errors.acknowledge}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-4">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                onClick={prevStep}
                                            >
                                                <i className="fa-solid fa-arrow-left"></i> Previous
                                            </button>

                                            <button type="submit" className="btn btn-success">
                                                <i className="fa-solid fa-check"></i> Submit
                                            </button>
                                        </div>

                                    </>
                                )}
                            </Form>
                        </Card.Body>
                    </Card>
                </Container>
            ) : (
                <div
                    style={{
                        textAlign: "center",
                        marginTop: "20%",
                        fontSize: "24px",
                        color: "yellow",
                    }}
                >
                    🚫 The application form is closed.
                    <br />
                    आवेदन पत्र बंद कर दिया गया है।
                    <br />
                    {formDetails && (
                        <div style={{ marginTop: "15px", fontSize: "18px", color: "white" }}>
                            Allowed Dates:{" "}
                            <strong>
                                {moment(formDetails.form_entry_start_date).format("DD-MM-YYYY")} →{" "}
                                {moment(formDetails.form_entry_end_date).format("DD-MM-YYYY")}
                            </strong>
                        </div>
                    )}
                </div>
            )}



        </div >

    )
}